(function () {
  var root = document.querySelector('[data-rsi-lnb]');
  if (!root) return;

  var dataEl = root.querySelector('[data-rsi-lnb-data]');
  if (!dataEl) return; // empty/coming-soon state — nothing to wire up

  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var mainImage = root.querySelector('[data-rsi-lnb-main-image]');
  var thumbsHost = root.querySelector('[data-rsi-lnb-thumbs]');
  var designButtons = Array.prototype.slice.call(root.querySelectorAll('[data-rsi-lnb-design] .rsi-lnb__design-option'));
  var levelsSelect = root.querySelector('[data-rsi-lnb-levels]');
  var detailsField = root.querySelector('[data-rsi-lnb-custom-details]');
  var detailsInput = root.querySelector('[data-rsi-lnb-details]');
  var qtyInput = root.querySelector('[data-rsi-lnb-qty]');
  var qtyDec = root.querySelector('[data-rsi-lnb-qty-dec]');
  var qtyInc = root.querySelector('[data-rsi-lnb-qty-inc]');
  var priceDisplays = Array.prototype.slice.call(root.querySelectorAll('[data-rsi-lnb-price-display]'));
  var addBtn = root.querySelector('[data-rsi-lnb-add]');
  var statusEl = root.querySelector('[data-rsi-lnb-status]');
  var basketPanel = root.querySelector('[data-rsi-lnb-basket]');
  var basketList = root.querySelector('[data-rsi-lnb-basket-list]');
  var descriptionHost = root.querySelector('[data-rsi-lnb-description]');

  var state = { design: 'custom', activeImageIndex: 0 };
  var orderLines = []; // { label, qty }, this session only — the real cart is Shopify's own

  function currentProduct() {
    return data[state.design];
  }

  function renderGallery() {
    var product = currentProduct();
    var images = product.images || [];
    if (!images.length) return;

    if (state.activeImageIndex >= images.length) state.activeImageIndex = 0;
    var active = images[state.activeImageIndex];
    mainImage.src = active.full;
    mainImage.alt = active.alt || product.title;

    thumbsHost.innerHTML = '';
    if (images.length < 2) return;
    images.forEach(function (img, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rsi-lnb__thumb' + (i === state.activeImageIndex ? ' is-active' : '');
      btn.setAttribute('aria-label', 'Show image ' + (i + 1));
      var thumbImg = document.createElement('img');
      thumbImg.src = img.thumb;
      thumbImg.alt = img.alt || product.title;
      btn.appendChild(thumbImg);
      btn.addEventListener('click', function () {
        state.activeImageIndex = i;
        renderGallery();
      });
      thumbsHost.appendChild(btn);
    });
  }

  function renderDesign() {
    var product = currentProduct();
    designButtons.forEach(function (btn) {
      var isActive = btn.getAttribute('data-value') === state.design;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    priceDisplays.forEach(function (el) {
      el.hidden = el.getAttribute('data-rsi-lnb-price-display') !== state.design;
    });
    detailsField.hidden = state.design !== 'custom';
    if (descriptionHost) descriptionHost.innerHTML = product.descriptionHtml;
    state.activeImageIndex = 0;
    renderGallery();
    clearStatus();
  }

  function clampQty() {
    var n = parseInt(qtyInput.value, 10);
    if (!n || n < 1) n = 1;
    if (n > 99) n = 99;
    qtyInput.value = n;
    return n;
  }

  function clearStatus() {
    statusEl.hidden = true;
    statusEl.textContent = '';
    statusEl.removeAttribute('data-state');
  }

  function showStatus(text, isError) {
    statusEl.hidden = false;
    statusEl.textContent = text;
    if (isError) statusEl.setAttribute('data-state', 'error');
    else statusEl.removeAttribute('data-state');
  }

  function renderBasket() {
    if (!orderLines.length) {
      basketPanel.hidden = true;
      return;
    }
    basketPanel.hidden = false;
    basketList.innerHTML = '';
    orderLines.forEach(function (line) {
      var li = document.createElement('li');
      var label = document.createElement('span');
      label.textContent = line.label;
      var qty = document.createElement('span');
      qty.textContent = '×' + line.qty;
      li.appendChild(label);
      li.appendChild(qty);
      basketList.appendChild(li);
    });
  }

  function addOrderLine(label, qty) {
    // Same design+levels added twice in a row (e.g. topping up quantity)
    // merges into one line instead of listing it twice.
    var existing = orderLines.filter(function (l) { return l.label === label; })[0];
    if (existing) existing.qty += qty;
    else orderLines.push({ label: label, qty: qty });
    renderBasket();
  }

  designButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var value = btn.getAttribute('data-value');
      if (value === state.design) return;
      state.design = value;
      renderDesign();
    });
  });

  levelsSelect.addEventListener('change', clearStatus);

  qtyDec.addEventListener('click', function () {
    qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
  });
  qtyInc.addEventListener('click', function () {
    qtyInput.value = Math.min(99, (parseInt(qtyInput.value, 10) || 1) + 1);
  });
  qtyInput.addEventListener('change', clampQty);

  addBtn.addEventListener('click', function () {
    var product = currentProduct();
    var levelLabel = levelsSelect.value;
    var variantId = product.variants[levelLabel];
    if (!variantId) {
      showStatus("Couldn't match that selection — please try again.", true);
      return;
    }

    var qty = clampQty();
    var payload = { id: variantId, quantity: qty };

    if (state.design === 'custom') {
      var details = (detailsInput.value || '').trim();
      payload.properties = {
        'Beam Levels': levelLabel,
        'Details to print': details || "Not provided — we'll call to confirm"
      };
    } else {
      payload.properties = { 'Beam Levels': levelLabel };
    }

    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';
    clearStatus();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [payload], sections: 'cart-icon-bubble' })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error((err && err.description) || 'Add to basket failed');
          });
        }
        return res.json();
      })
      .then(function (addData) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && addData.sections && addData.sections['cart-icon-bubble']) {
          bubble.innerHTML = addData.sections['cart-icon-bubble'];
        }
        var designLabel = state.design === 'custom' ? 'Custom Printed' : 'Blank';
        addOrderLine(designLabel + ' — ' + levelLabel, qty);
        showStatus('Added to your basket.', false);
      })
      .catch(function (err) {
        showStatus(err.message || 'Add to basket failed — please try again.', true);
      })
      .finally(function () {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Basket';
      });
  });

  renderDesign();
})();
